import React from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./components/loader/Loader";

const Home = React.lazy(() => import("./pages/home/Home"));
const Login = React.lazy(() => import("./pages/login/Login"));
const AgeVerify = React.lazy(() => import("./pages/ageVerify/AgeVerify"));
const AgeVerifyResult = React.lazy(() => import("./pages/ageVerifyResult/AgeVerifyResult"));
const TDSDetails = React.lazy(() => import("./pages/tdsDetails/TDSDetails"));
const StepProfile = React.lazy(() => import("./pages/step-profile/StepProfile"));
const NewLogin = React.lazy(() => import("./pages/new-login-flow/NewLogin"));
const EarningPotential = React.lazy(() => import("./pages/new-step-profile/components/EarningPotential/EarningPotential"));
const NewStepProfile = React.lazy(() => import("./pages/new-step-profile/NewStepProfile"));
const VerificationIntro = React.lazy(() => import("./pages/new-step-profile/screens/VerificationIntro/VerificationIntro"));
const FaceVerificationRecording = React.lazy(() => import("./pages/new-step-profile/screens/VerificationIntro/FaceVerificationRecording"));
const LivelinessImageVerification = React.lazy(() => import("./pages/new-step-profile/screens/VerificationIntro/LivelinessImageVerification"));
const ProfileImage = React.lazy(() => import("./pages/new-step-profile/components/ProfileImage/ProfileImage"));
const AgeVerification = React.lazy(() => import("./pages/new-step-profile/components/AgeVerification/AgeVerification"));
const TrainingStage = React.lazy(() => import("./pages/new-step-profile/screens/TrainingStage/TrainingStage"));
const QuizStage = React.lazy(() => import("./pages/new-step-profile/screens/Quiz/QuizStage"));
const QuizSuccess = React.lazy(() => import("./pages/new-step-profile/screens/Quiz/QuizSuccess"));
const OnboardingComplete = React.lazy(() => import("./pages/new-step-profile/screens/OnboardingComplete/OnboardingComplete"));
const AiCallInterface = React.lazy(() => import("./pages/new-step-profile/demo-training-call/AiCallInterface"));
const PracticeCall = React.lazy(() => import("./pages/new-step-profile/demo-training-call/PracticeCall"));
const OpenlyLogin = React.lazy(() => import("./pages/login/openly/Openly"));

function App() {
  return (
    <>
      <ToastContainer
        limit={1}
        autoClose={3000}
        position="top-center"
        theme={
          window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
            ? "dark"
            : "light"
        }
      />
      <React.Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<NewLogin />} />
          <Route path="/profile" element={<NewStepProfile />} />
          <Route path="/age-verify" element={<AgeVerify />} />
          <Route path="/age-verify/:result" element={<AgeVerifyResult />} />
          <Route path="/tds-details" element={<TDSDetails />} />
          <Route path="/earning-potential" element={<EarningPotential />} />
          <Route path="/new-step-profile" element={<NewStepProfile />} />
          <Route path="/openly-login" element={<OpenlyLogin />} />
          <Route path="/verification-intro" element={<VerificationIntro />} />
          <Route path="/face-verification-recording" element={<FaceVerificationRecording />} />
          <Route path="/liveliness-image-verification" element={<LivelinessImageVerification />} />
          <Route path="/profile-image" element={<ProfileImage />} />
          <Route path="/age-verification" element={<AgeVerification />} />
          <Route path="/training-stage" element={<TrainingStage />} />
          <Route path="/quiz-stage" element={<QuizStage />} />
          <Route path="/quiz-success" element={<QuizSuccess />} />
          <Route path="/ai-call-interface" element={<AiCallInterface />} />
          <Route path="/training-call" element={<PracticeCall />} />
          <Route path="/onboarding-complete" element={<OnboardingComplete />} />
        </Routes>
      </React.Suspense>
    </>
  );
}

export default App;
